import React from "react";
import AnnouncementBar from "@/components/landing/AnnouncementBar";
import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";

export default function StoreShell({ testid, children, dir }) {
    return (
        <div data-testid={testid} dir={dir} className="min-h-screen bg-cream text-forest-900 font-sans">
            <AnnouncementBar />
            <Header />
            {children}
            <Footer />
        </div>
    );
}
